// extracted by mini-css-extract-plugin
export var shake = "_d-0";